:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._fd-column{flex-direction:column;}
:root ._gap-t-space-sma3456{gap:var(--t-space-small);}
:root ._pos-relative{position:relative;}
:root ._pos-absolute{position:absolute;}
:root ._t--6px{top:-6px;}
:root ._fd-row{flex-direction:row;}
:root ._gap-t-space-med104641{gap:var(--t-space-medium);}
:root ._items-center{align-items:center;}
:root ._ff-f-family{font-family:var(--f-family);}
:root ._dsp-inline{display:inline;}
:root ._ww-break-word{word-wrap:break-word;}
:root ._ws-pre-wrap{white-space:pre-wrap;}
:root ._mt-0px{margin-top:0px;}
:root ._mr-0px{margin-right:0px;}
:root ._mb-0px{margin-bottom:0px;}
:root ._ml-0px{margin-left:0px;}
:root ._col-color{color:var(--color);}
:root ._lh-32px{line-height:32px;}
:root ._fs-32px{font-size:32px;}
:root ._shrink-1{flex-shrink:1;}
:root ._grow-1{flex-grow:1;}
:root ._cur-pointer{cursor:pointer;}
:root ._pt-1px{padding-top:1px;}
:root ._pr-1px{padding-right:1px;}
:root ._pb-1px{padding-bottom:1px;}
:root ._pl-1px{padding-left:1px;}
:root ._btlr-1000px{border-top-left-radius:1000px;}
:root ._btrr-1000px{border-top-right-radius:1000px;}
:root ._bbrr-1000px{border-bottom-right-radius:1000px;}
:root ._bblr-1000px{border-bottom-left-radius:1000px;}
:root ._pt-5px{padding-top:5px;}
:root ._pr-5px{padding-right:5px;}
:root ._pb-5px{padding-bottom:5px;}
:root ._pl-5px{padding-left:5px;}
:root ._bg-c-primary{background-color:var(--c-primary);}